import { Box, Button } from '@mui/material';
import ProductList from './components/ProductList';
import useStoreSlug from 'src/common/hooks/useStoreSlug';
import { useSearch } from 'src/context/SearchProvider/useSearch';
import useSearchProducts from './hooks/useSearchProducts';
import { CenteredContentContainer, FlexContainer } from 'src/components/styles';
import { useAppUI } from 'src/context/AppUIProvider/useAppUI';
import { InfoOutlined } from '@mui/icons-material';
import ProductGridSkeleton from 'src/features/products/presentation/components/ProductGridSkeleton';
import LineClampTypography from 'src/components/common/ui/LineClampTypography';
import useTrackProductsSearch from 'src/features/products/presentation/hooks/useTrackProductsSearch';
import EmptyStateBox from 'src/components/common/ui/EmptyStateBox';

const ProductResults = () => {
  const { isXs } = useAppUI();
  const { storeSlug } = useStoreSlug();
  const { searchTerm, debouncedSearchTerm, isChanging, clearSearch } =
    useSearch();
  const { products, isLoading } = useSearchProducts({
    storeSlug,
    search: debouncedSearchTerm,
  });

  useTrackProductsSearch({
    debouncedSearchTerm,
    isLoading,
    isChanging,
    products,
  });

  return (
    <Box width="100%" px={{ xs: 1, md: 0 }}>
      <>
        <FlexContainer alignItems="center" gap={1} pb={{ xs: 2, md: 3 }}>
          <LineClampTypography
            typographyProps={{ variant: 'subtitle1', fontWeight: 'bold' }}
            lines={2}
            content={`Resultados para: ${searchTerm}`}
            disableFulltextToggle
          />
        </FlexContainer>
        {isLoading || isChanging ? (
          <ProductGridSkeleton />
        ) : products.length ? (
          <ProductList
            productCardProps={{
              height: { xs: '180px', sm: '225px', md: '250px' },
              maxTitleLines: isXs ? 2 : undefined,
            }}
            products={products}
          />
        ) : (
          <CenteredContentContainer mt={10}>
            <EmptyStateBox
              title="No se encontraron resultados"
              icon={<InfoOutlined fontSize="large" color="primary" />}
              primaryButton={
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={clearSearch}
                  sx={{ mt: 1, minWidth: '160px', mx: 'auto' }}
                >
                  Limpiar búsqueda
                </Button>
              }
            />
          </CenteredContentContainer>
        )}
      </>
    </Box>
  );
};

export default ProductResults;
